import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyNotFound = lazy(() => import('./NotFound'));

export const NotFound: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyNotFound {...props} />
	</Suspense>
);
